@if ((consent$ | async); as consent) {
  @if (!consent.decided) {
    <div class="cb-overlay" role="dialog" aria-modal="true"
      [attr.aria-label]="'cookies.banner.title' | tr">
      <!-- ── Compact bar ──────────────────────────────────────────────────── -->
      <div class="cb-bar">
        <div class="cb-bar__text">
          <ion-icon name="shield-checkmark-outline" class="cb-bar__icon"></ion-icon>
          <p class="cb-bar__desc">
            {{ 'cookies.banner.description' | tr }}
            <a [href]="legal.url('datenschutz')" target="_blank" rel="noopener noreferrer"
              class="cb-bar__link">{{ 'cookies.banner.privacyLink' | tr }}</a>.
          </p>
        </div>
        <div class="cb-bar__actions">
          <button class="cb-btn cb-btn--link" (click)="toggleDetails()" type="button">
            {{ 'cookies.banner.settings' | tr }}
            <ion-icon [name]="showDetails ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </button>
          <button class="cb-btn cb-btn--outline" (click)="acceptEssential()" type="button">
            {{ 'cookies.banner.essential' | tr }}
          </button>
          <button class="cb-btn cb-btn--primary" (click)="acceptAll()" type="button">
            {{ 'cookies.banner.acceptAll' | tr }}
          </button>
        </div>
      </div>
      <!-- ── Details panel ────────────────────────────────────────────────── -->
      @if (showDetails) {
        <div class="cb-details">
          <!-- Essential (always on) -->
          <div class="cb-category">
            <div class="cb-category__row">
              <div class="cb-category__info">
                <span class="cb-category__name">{{ 'cookies.category.essential.name' | tr }}</span>
                <p class="cb-category__desc">{{ 'cookies.category.essential.desc' | tr }}</p>
              </div>
              <ion-badge color="success" class="cb-always-on">{{ 'cookies.alwaysOn' | tr }}</ion-badge>
            </div>
          </div>
          <!-- Functional (toggleable) -->
          <div class="cb-category">
            <div class="cb-category__row">
              <div class="cb-category__info">
                <span class="cb-category__name">{{ 'cookies.category.functional.name' | tr }}</span>
                <p class="cb-category__desc">{{ 'cookies.category.functional.desc' | tr }}</p>
              </div>
              <ion-toggle
                [checked]="functionalEnabled"
                (ionChange)="functionalEnabled = $event.detail.checked"
                color="primary"
                class="cb-toggle">
              </ion-toggle>
            </div>
          </div>
          <div class="cb-details__footer">
            <button class="cb-btn cb-btn--primary" (click)="saveSettings()" type="button">
              {{ 'cookies.banner.save' | tr }}
            </button>
          </div>
        </div>
      }
    </div>
  }
}
